import { TFunction } from 'next-i18next'
import { HttpRequestError } from '@frontend/lib/request'

import { isAPIErrorCode } from '@shared/error-codes'

export const handleErrorCodes = (err: unknown) => {
  if (
    err instanceof HttpRequestError &&
    err.response.data?.code &&
    isAPIErrorCode(err.response.data.code)
  ) {
    return err.response.data.code
  }

  return null
}

export const retrieveErrorMessage = (err: unknown): string | null => {
  if (err instanceof HttpRequestError && err.response.data?.message) {
    return err.response.data.message
  }

  if (err instanceof Error) {
    return err.message
  }

  return null
}

export function ErrorCode({ err, t }: { err: unknown; t: TFunction }) {
  return retrieveErrorCode({ err, t })
}

export function retrieveErrorCode({ err, t }: { err: unknown; t: TFunction }) {
  const matchingCode = handleErrorCodes(err)

  if (matchingCode) {
    return t(matchingCode, { ns: 'error_codes' })
  }

  const retrievedErrorMessage = retrieveErrorMessage(err)

  if (retrievedErrorMessage) {
    return retrievedErrorMessage
  }

  return t('UNEXPECTED_ERROR')
}
